import type { ReactNode } from "react";
import { Breadcrumbs } from "./Breadcrumbs";

export function PageContainer({ children }: { children: ReactNode }) {
  return <main className="flex-1 p-4 md:p-6"><div className="mx-auto max-w-[1500px] space-y-6"><Breadcrumbs />{children}</div></main>;
}
